export const ICON_NAMES = [
  "abstract-11",
  "arrow-right-left",
  "barcode",
  "calendar",
  "copy",
  "copy-success",
  "credit-card",
  "down",
  "lock-2",
  "pix",
  "right",
  "check",
  "user",
] as const;
